import {
  Component,
  OnInit,
  Inject,
  AfterViewInit,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { CornerstoneService } from "app/services/cornerstone.service";
import { GlobalVariable } from "app/global/global";
import { CornerstoneDirective } from "app/directives/cornerstone.directive";
import { AyudaBotonesComponent } from "./ayuda-botones/ayuda-botones.component";
import { ArchivoService } from "../../services/archivo.service";

@Component({
  selector: "app-show-imagen",
  templateUrl: "./show-imagen.component.html",
  styleUrls: ["./show-imagen.component.scss"],
})
export class ShowImagenComponent implements OnDestroy, OnInit, AfterViewInit {
  @ViewChild(CornerstoneDirective) cornerstoneDirective: CornerstoneDirective;
  constructor(
    private dialogRef: MatDialogRef<ShowImagenComponent>,
    @Inject(MAT_DIALOG_DATA) public mensaje: any,
    private csS: CornerstoneService,
    public dialog: MatDialog,
    private archivoService: ArchivoService
  ) {}

  url: string = GlobalVariable.BASE_API_URL + "storage/images/paciente/";
  urlCM: string =
    GlobalVariable.BASE_API_URL + "storage/images/centro-medico/carousel/";
  imageData: any;
  sideBar = true;
  login: boolean = false;
  img: any;
  extd: string;
  xlsVisualizer: string = GlobalVariable.BASE_LUCKYEXCEL_URL;
  selectedTool = "";
  loading: boolean = false;

  ngOnInit(): void {
    this.Init();
  }

  ngAfterViewInit(): void {}

  private Init() {
    if (this.mensaje instanceof File) {
      const file = this.mensaje;

      this.extd = file.name.split(".").pop();
      if (this.extd == "DCM" || this.extd == "dcm") {
        this.extd = "dcm";
        this.imageData = window.URL.createObjectURL(file);
        this.csS.fetchLocalDicomImage(this.imageData).subscribe((res) => {
          this.imageData = res;
        });
      } else if (this.extd == "pdf" || this.extd == "PDF") {
        this.extd = "pdf";
        this.imageData = window.URL.createObjectURL(file);
      } else if (this.extd == "xlsx") {
        this.extd = "xlsx";
        this.imageData = "Debe guardar el estudio para poder visualizarlo";
      } else {
        this.extd = "img";
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    } else {
      if (!this.mensaje.nombreImagen) {
        this.extd = this.mensaje.nombre.split(".").pop();
        const idPaciente = this.mensaje.idPaciente;
        const idEstudio = this.mensaje.idEstudioMedico;
        const nombre = this.mensaje.nombre;

        if (this.extd === "xlsx" || this.extd === "xls") {
          this.loading = true;
          this.extd = "xlsx";

          this.archivoService
            .getLinkTemporal(idPaciente, idEstudio, nombre)
            .subscribe({
              next: (url) => {
                const luckyUrl = this.xlsVisualizer + encodeURIComponent(url);
                this.imageData = luckyUrl;
                this.loading = false;
              },
              error: (err) => {
                console.error("Error obteniendo link temporal", err);
                this.imageData = "Error al cargar archivo";
                this.loading = false;
              },
            });

          return;
        }

        if (this.extd == "DCM" || this.extd == "dcm") {
          this.loading = true;
          this.extd = "dcm";
          this.csS
            .fetchDicomImage({
              ...this.mensaje,
            })
            .subscribe({
              next: (res) => {
                this.loading = false;
                setTimeout(() => {
                  this.imageData = res;
                });
              },
              error: (err) => {
                console.error("Error obteniendo link temporal", err);
                this.imageData = "Error al cargar archivo";
                this.loading = false;
              },
            });
          return;
        }

        this.loading = true;
        this.archivoService
          .getImagenProtegida(idPaciente, idEstudio, nombre)
          .subscribe({
            next: async (blob) => {
              if (this.extd === "pdf" || this.extd === "PDF") {
                this.extd = "pdf";
                this.imageData = URL.createObjectURL(blob);
                this.loading = false;
              } else {
                this.extd = "img";
                this.imageData = await this.archivoService.blobToSafeUrl(blob);
                this.loading = false;
              }
            },
            error: (err) => {
              console.error("Error al cargar archivo:", err);
              this.imageData = "Error al cargar archivo";
              this.loading = false;
            },
          });
      } else {
        this.imageData = this.urlCM + this.mensaje.nombreImagen;
        this.extd = this.mensaje.nombreImagen.split(".").pop();
      }
    }
  }

  openSideBar(event) {
    this.sideBar = !this.sideBar;
  }

  onClickNo() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.csS = null;
  }
  activateTool(toolName: string, mouseButtonMask?: number) {
    if (this.cornerstoneDirective) {
      this.selectedTool = toolName;
      this.cornerstoneDirective.activateTool(toolName, mouseButtonMask);
    }
  }

  resetView() {
    if (this.cornerstoneDirective) {
      this.selectedTool = "";
      this.cornerstoneDirective.resetView();
    }
  }

  zoomIn() {
    if (this.cornerstoneDirective) {
      this.cornerstoneDirective.zoomIn();
    }
  }

  zoomOut() {
    if (this.cornerstoneDirective) {
      this.cornerstoneDirective.zoomOut();
    }
  }

  openHelp() {
    const dialogRef = this.dialog.open(AyudaBotonesComponent, {
      maxWidth: "500px",
    });
  }
}
